// extracted by mini-css-extract-plugin
export default {"pageWrapper":"classes@desktop_pageWrapper__RaP5V"};